export default "__VITE_ASSET__5b715f81__"